'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");

function algoToString(algo) {
  switch (algo) {
    case /* Greedy */0 :
        return "greedy";
    case /* Ordered */1 :
        return "ordered";
    case /* PTAS */2 :
        return "ptas";
    case /* BruteForce */3 :
        return "bruteForce";
    
  }
}

function algoToRunningTime(algo) {
  switch (algo) {
    case /* Greedy */0 :
    case /* Ordered */1 :
        return "O(n<sup>2</sup>)";
    case /* PTAS */2 :
        return "O(((1-ε)n)! + (εn)<sup>2</sup>)";
    case /* BruteForce */3 :
        return "O(n!)";
    
  }
}

function algoToApproxRatio(algo) {
  switch (algo) {
    case /* Greedy */0 :
        return "2 - 1/m";
    case /* Ordered */1 :
        return "3/2";
    case /* PTAS */2 :
        return "1 + ε";
    case /* BruteForce */3 :
        return "1";
    
  }
}

function stringToAlgo(str) {
  switch (str) {
    case "bruteForce" :
        return /* BruteForce */3;
    case "greedy" :
        return /* Greedy */0;
    case "ordered" :
        return /* Ordered */1;
    case "ptas" :
        return /* PTAS */2;
    default:
      return ;
  }
}

function createMachine(id) {
  return {
          id: id,
          jobs: /* [] */0,
          load: 0
        };
}

function assign(job, machine) {
  return {
          id: machine.id,
          jobs: {
            hd: job,
            tl: machine.jobs
          },
          load: machine.load + job | 0
        };
}

function unassign(job, machine) {
  var isFound = {
    contents: false
  };
  var newJobs = List.filter(function (j) {
          if (!isFound.contents && j === job) {
            isFound.contents = true;
            return false;
          } else {
            return true;
          }
        })(machine.jobs);
  return {
          id: machine.id,
          jobs: newJobs,
          load: machine.load - job | 0
        };
}

function pop(machine) {
  var match = machine.jobs;
  if (match) {
    return {
            id: machine.id,
            jobs: match.tl,
            load: machine.load - match.hd | 0
          };
  } else {
    return machine;
  }
}

function getMakespan(param) {
  return $$Array.fold_left((function (maximum, machine) {
                if (maximum > machine.load) {
                  return maximum;
                } else {
                  return machine.load;
                }
              }), Pervasives.min_int, param);
}

function greedyInternal(jobs, machines) {
  $$Array.iter((function (job) {
          var index = {
            contents: -1
          };
          var minimum = {
            contents: Pervasives.max_int
          };
          $$Array.iteri((function (i, machine) {
                  if (machine.load < minimum.contents) {
                    index.contents = i;
                    minimum.contents = machine.load;
                    return ;
                  }
                  
                }), machines);
          return Caml_array.caml_array_set(machines, index.contents, assign(job, Caml_array.caml_array_get(machines, index.contents)));
        }), jobs);
  return machines;
}

function greedy(jobs, m) {
  var machines = $$Array.init(m, createMachine);
  return greedyInternal(jobs, machines);
}

function ordered(jobs, m) {
  var jobsCopy = $$Array.copy(jobs);
  $$Array.fast_sort((function (job1, job2) {
          return job2 - job1 | 0;
        }), jobsCopy);
  return greedy(jobsCopy, m);
}

function bruteForce(jobs, m) {
  var machines = $$Array.init(m, createMachine);
  var jobsCopy = $$Array.copy(jobs);
  $$Array.fast_sort((function (job1, job2) {
          return job2 - job1 | 0;
        }), jobsCopy);
  var jobsList = $$Array.to_list(jobsCopy);
  var bruteForceRec = function (jobsList, machines, bestMakespan) {
    if (getMakespan(machines) >= bestMakespan) {
      return [
              machines,
              Pervasives.max_int
            ];
    }
    if (!jobsList) {
      return [
              machines,
              getMakespan(machines)
            ];
    }
    var restJobs = jobsList.tl;
    var nextJob = jobsList.hd;
    var bestMachinesLocal = {
      contents: []
    };
    var bestMakespanLocal = {
      contents: Pervasives.max_int
    };
    $$Array.iteri((function (i, param) {
            Caml_array.caml_array_set(machines, i, assign(nextJob, Caml_array.caml_array_get(machines, i)));
            var match = bruteForceRec(restJobs, machines, bestMakespan < bestMakespanLocal.contents ? bestMakespan : bestMakespanLocal.contents);
            var newMakespan = match[1];
            if (newMakespan < (
                bestMakespan < bestMakespanLocal.contents ? bestMakespan : bestMakespanLocal.contents
              )) {
              bestMachinesLocal.contents = $$Array.copy(match[0]);
              bestMakespanLocal.contents = newMakespan;
            }
            return Caml_array.caml_array_set(machines, i, pop(Caml_array.caml_array_get(machines, i)));
          }), machines);
    return [
            bestMachinesLocal.contents,
            bestMakespanLocal.contents
          ];
  };
  return bruteForceRec(jobsList, machines, Pervasives.max_int)[0];
}

function ptas(jobs, m, eps) {
  var jobsCopy = $$Array.copy(jobs);
  $$Array.fast_sort((function (job1, job2) {
          return job2 - job1 | 0;
        }), jobsCopy);
  var n = jobsCopy.length;
  var greedyJobsLength = Math.floor(n * eps) | 0;
  var bfJobs = $$Array.sub(jobsCopy, 0, n - greedyJobsLength | 0);
  var greedyJobs = $$Array.sub(jobsCopy, n - greedyJobsLength | 0, greedyJobsLength);
  var bfMachines = bruteForce(bfJobs, m);
  return greedyInternal(greedyJobs, bfMachines);
}

exports.algoToString = algoToString;
exports.algoToRunningTime = algoToRunningTime;
exports.algoToApproxRatio = algoToApproxRatio;
exports.stringToAlgo = stringToAlgo;
exports.createMachine = createMachine;
exports.assign = assign;
exports.unassign = unassign;
exports.pop = pop;
exports.getMakespan = getMakespan;
exports.greedyInternal = greedyInternal;
exports.greedy = greedy;
exports.ordered = ordered;
exports.bruteForce = bruteForce;
exports.ptas = ptas;
/* No side effect */
